// src/features/study/hooks/useArtifactSaveActions.js
import { useCallback } from "react";
import TurndownService from "turndown";
import { gfm } from "turndown-plugin-gfm";

import { apiFetch } from "../../../services/apiClient";

export function useArtifactSaveActions({
  artifact,
  artifactId,
  editor,
  editedContent,
  parseSurveyData,
}) {
  const handleSaveSurveyJS = useCallback(
    async (content) => {
      try {
        const response = await apiFetch(`/artifacts/${artifactId}`, {
          method: "PUT",
          body: JSON.stringify({ content }),
        });

        if (response.ok) {
          window.location.reload();
        } else {
          alert("저장 실패");
        }
      } catch (err) {
        console.error("저장 오류:", err);
        alert("저장 중 오류가 발생했습니다");
      }
    },
    [artifactId]
  );

  const handleSave = useCallback(async () => {
    try {
      let contentToSave = editedContent;

      if (editor && artifact.artifact_type !== "survey") {
        const turndownService = new TurndownService({
          headingStyle: "atx",
          bulletListMarker: "*",
          codeBlockStyle: "fenced",
          tableCellPadding: " ",
          tableCellAlignment: "left",
        });

        turndownService.use(gfm);

        turndownService.addRule("table", {
          filter: "table",
          replacement: function (content, node) {
            const rows = node.querySelectorAll("tr");
            let markdown = "";

            rows.forEach((row, index) => {
              const cells = row.querySelectorAll("th, td");
              const cellContents = Array.from(cells).map((cell) => {
                return cell.textContent.trim().replace(/\n/g, " ").replace(/\s+/g, " ");
              });

              markdown += "| " + cellContents.join(" | ") + " |\n";

              if (index === 0) {
                const separator = "|" + cellContents.map(() => " --- ").join("|") + "|";
                markdown += separator + "\n";
              }
            });

            return markdown + "\n";
          },
        });

        const html = editor.getHTML();
        contentToSave = turndownService.turndown(html);

        contentToSave = contentToSave
          .replace(/\|\s*\|\s*\|\s*\n/g, "|\n")
          .replace(/\|\s*\n/g, "|\n")
          .replace(/\|\s*$/gm, "|");

        contentToSave = contentToSave.replace(/^```markdown\n/, "").replace(/\n```$/, "");
        contentToSave = contentToSave.replace(/^```\n/, "").replace(/\n```$/, "");
      }

      const response = await apiFetch(`/artifacts/${artifactId}`, {
        method: "PUT",
        body: JSON.stringify({ content: contentToSave }),
      });

      if (response.ok) {
        window.location.reload();
      } else {
        alert("저장 실패");
      }
    } catch (err) {
      console.error("저장 오류:", err);
      alert("저장 중 오류가 발생했습니다");
    }
  }, [artifact, artifactId, editor, editedContent]);

  return { handleSave, handleSaveSurveyJS };
}
